<template>
  <v-data-table
    hide-actions
    :headers="headers"
    :items="datesItems"
    class="elevation-0 pa-1"
    :style="{ 'overflow-y': 'auto', height: `${tableHeight}px` }"
  >
    <template
      slot="headers"
      slot-scope="props"
    >
      <tr class="text-xs-left">
        <th
          v-for="header in props.headers"
          :key="header.text"
          class="pa-1"
        >
          {{ header.text }}
        </th>
      </tr>
    </template>
    <template
      slot="items"
      slot-scope="props"
    >
      <td class="blue--text text--darken-4">
        {{ props.item.name }}
      </td>

      <td class="date-picker">
        <span
          v-if="props.item.request && props.item.request.type === 'string-list'"
        >
          {{ props.item.request.value | stringList(true) }}</span>
        <app-date-picker
          v-else-if="
            props.item.request &&
              props.item.request.editable &&
              typeof props.item.request.value !== 'object'
          "
          v-model="props.item.request.value"
          :disabled="disabled ? canEdit : !canEdit"
          :without-initial-data="true"
          :padding="0"
          :outline="false"
          :hide-data-type-icon="true"
          @input="changeDates(props.item.request.fieldName)"
        />
        <DateRangePicker
          v-else-if="
            props.item.request &&
              props.item.request.editable &&
              typeof props.item.request.value === 'object'
          "
          v-model="props.item.request.value"
          :disabled="disabled ? canEdit : !canEdit"
          :clearable="false"
          :outline="false"
          :hide-data-type-icon="true"
          @input="changeDates(props.item.request.fieldName)"
        />
        <span
          v-else-if="
            props.item.request &&
              !props.item.request.editable &&
              typeof props.item.request.value === 'object'
          "
        >
          {{ props.item.request.value | dateRange }}
        </span>
        <span v-else-if="props.item.request && props.item.request.notDate">{{
          props.item.request.value
        }}</span>
        <span v-else-if="props.item.request && !props.item.request.notDate">{{
          props.item.request.value | date
        }}</span>
      </td>

      <td class="date-picker">
        <span v-if="props.item.plan.type === 'string-list'">
          {{ props.item.plan.value | stringList(true) }}</span>
        <app-date-picker
          v-else-if="
            props.item.plan.editable &&
              typeof props.item.plan.value !== 'object'
          "
          v-model="props.item.plan.value"
          :disabled="disabled ? canEdit : !canEdit"
          :without-initial-data="true"
          :padding="0"
          :outline="false"
          :hide-data-type-icon="true"
          @input="changeDates(props.item.plan.fieldName)"
        />
        <DateRangePicker
          v-else-if="
            props.item.plan.editable &&
              typeof props.item.plan.value === 'object'
          "
          v-model="props.item.plan.value"
          :min="minDate"
          :disabled="disabled ? canEdit : !canEdit"
          :clearable="false"
          :outline="false"
          :hide-data-type-icon="true"
          @input="changeDates(props.item.plan.fieldName)"
        />
        <v-tooltip
          v-else-if="
            !props.item.plan.editable &&
              typeof props.item.plan.value === 'object'
          "
          bottom
        >
          <template v-slot:activator="{ on }">
            <span v-on="props.item.plan.explanationIfNotEditable ? on : null">
              {{ props.item.plan.value | dateRange }}</span>
          </template>
          <span>{{ props.item.plan.explanationIfNotEditable }}</span>
        </v-tooltip>
        <v-tooltip
          v-else-if="!props.item.plan.notDate"
          bottom
        >
          <template v-slot:activator="{ on }">
            <span v-on="props.item.plan.explanationIfNotEditable ? on : null">
              <span v-if="props.item.plan.value">
                {{ props.item.plan.value | date }}
              </span>
              <span v-else>
                {{ "_" }}
              </span>
            </span>
          </template>
          <span>{{ props.item.plan.explanationIfNotEditable }}</span>
        </v-tooltip>
        <span v-else>{{ props.item.plan.value | date }}</span>
      </td>

      <td class="date-picker">
        <span v-if="props.item.fact.type === 'string-list'">{{
          props.item.fact.value | stringList(true)
        }}</span>
        <app-date-picker
          v-else-if="
            props.item.fact.editable &&
              typeof props.item.fact.value !== 'object'
          "
          v-model="props.item.fact.value"
          class="mx-2"
          :disabled="disabled ? canEdit : !canEdit"
          :without-initial-data="true"
          :padding="0"
          :outline="false"
          :hide-data-type-icon="true"
          @input="changeDates(props.item.fact.fieldName)"
        />
        <DateRangePicker
          v-else-if="
            props.item.fact.editable &&
              typeof props.item.fact.value === 'object'
          "
          v-model="props.item.fact.value"
          :disabled="disabled ? canEdit : !canEdit"
          :clearable="false"
          :outline="false"
          :hide-data-type-icon="true"
          @input="changeDates(props.item.fact.fieldName)"
        />
        <span
          v-else-if="
            !props.item.fact.editable &&
              typeof props.item.fact.value === 'object'
          "
        >
          {{ props.item.fact.value | dateRange }}</span>
        <span v-else-if="!props.item.fact.notDate">{{
          props.item.fact.value | date
        }}</span>
        <span v-else>{{ props.item.fact.value }}</span>
      </td>
    </template>
  </v-data-table>
</template>

<script>
import {
  changeShippingDate,
  changeReadyForShipmentPlan,
  changeDesiredDeliveryDatePlan,
  changeFactoryClosingPlanDate,
} from "../../../backend/shippingsApi.js";
import { phaseStates } from "./phases/shipping-phase-states.js";
import { ePhaseTypes } from "./phases/shipping-phase-types.js";
import auth from "../../../auth.js";

export default {
  props: ["id", "canEdit", "tableHeight", "disabled"],
  computed: {
    datesItems() {
      if (this.dates.readyToLoadDates) {
        const readyToLoadRow = this.items[0];
        readyToLoadRow.request.value =
          this.dates.readyToLoadDates.request || "";
        readyToLoadRow.plan.value = this.dates.readyToLoadDates.plan || "";
        readyToLoadRow.fact.value = this.dates.readyToLoadDates.fact || "";
      }
      if (this.dates.dateOfExportFromFactory) {
        const dateOfExportFromFactory = this.items[1];
        dateOfExportFromFactory.request.value =
          this.dates.dateOfExportFromFactory.request || "_";
        dateOfExportFromFactory.plan.value =
          this.dates.dateOfExportFromFactory.plan || "";
        dateOfExportFromFactory.fact.value =
          this.dates.dateOfExportFromFactory.fact || "";
      }
      if (this.dates.factoryClosing) {
        const factoryClosing = this.items[2];
        factoryClosing.request.value = this.dates.factoryClosing.request || "";
        factoryClosing.plan.value = this.dates.factoryClosing.plan || "";
        factoryClosing.fact.value = this.dates.factoryClosing.fact || "";
      }
      if (this.dates.wantedDates) {
        const wantedDates = this.items[3];
        wantedDates.request.value = this.dates.wantedDates.request || "";
        wantedDates.plan.value = this.dates.wantedDates.plan || "";
        wantedDates.fact.value = this.dates.wantedDates.fact || "";
      }
      if (this.dates.deliveryToUnloading) {
        const deliveryToUnloading = this.items[4];
        deliveryToUnloading.request.value =
          this.dates.deliveryToUnloading.request || "";
        deliveryToUnloading.plan.value =
          this.dates.deliveryToUnloading.plan || "";
        deliveryToUnloading.fact.value =
          this.dates.deliveryToUnloading.fact || "";
      }
      if (this.dates.shipmentFromStoreKiev) {
        const shipmentFromStoreKiev = this.items[5];
        shipmentFromStoreKiev.plan.value =
          this.dates.shipmentFromStoreKiev.plan || "";
        shipmentFromStoreKiev.fact.value =
          this.dates.shipmentFromStoreKiev.fact || "";
      }

      return [...this.items];
    },
    minDate() {
      return this.moment(this.datesItems[0].request.value, "YYYY-MM-DD")
        .add(1, "days")
        .format("YYYY-MM-DD");
    },
    dates() {
      return this.$store.getters["shipping/dates"];
    },
    headers() {
      return this.$store.getters["shipping/datesHeaders"];
    },
    phases() {
      return this.$store.getters["shipping/phases"];
    },
    isInRoute() {
      return !!this.phases.find(p => p.route);
    },
    items() {
      return [
        {
          value: false,
          name: "Дата готовности",
          request: { value: "" },
          plan: {
            value: "",
            editable: this.checkCanEditReadyToLoadDates(),
            fieldName: "readyPlan",
            explanationIfNotEditable: this.firstPhaseInProcess
              ? "Первое звено в процессе выполнения, изменение даты запрещено"
              : "",
          },
          fact: { value: "" },
        },
        {
          value: false,
          name: "Дата заезда к отправителю",
          request: { value: "_", notDate: true },
          plan: {
            value: "",
            fieldName: "dateOfExportFromFactory",
            explanationIfNotEditable: this.firstPhaseInProcess
              ? "Первое звено в процессе выполнения, изменение даты запрещено"
              : "",
          },
          fact: { value: "" },
        },
        {
          value: false,
          name: "Дата закрытия Фабрики",
          request: { value: "" },
          plan: {
            value: "",
            fieldName: "factoryClosing",
            editable: this.checkCanEditFactoryClosing(),

            explanationIfNotEditable: this.hasPickUpPhaseInRoute
              ? "Звено Заезд в статусе В Маршруте, изменение даты запрещено"
              : "",
          },
          fact: {
            value: "",
          },
        },
        {
          value: false,
          name: "Желаемая дата доставки",
          request: { value: "" },
          plan: {
            value: "",
            editable:
              this.editableWantedDatePlan &&
              (this.isClientManager || this.isAdmin),
            fieldName: "wantedDatePlan",
          },
          fact: { value: "" },
        },
        {
          value: false,
          name: "Дата доставки",
          request: { value: "" },
          plan: { value: "" },
          fact: { value: "" },
        },
        {
          value: false,
          name: "Отгрузка",
          plan: { value: "", type: "string-list" },
          fact: { value: "" },
        },
      ];
    },
    phaseInRoute() {
      return this.phases.some(item => {
        return item.state.id === phaseStates.INROUTE;
      });
    },
    firstPhaseInProcess() {
      return !!this.phases.find((item, index) => {
        if (index === 0) {
          return (
            item.state.id === phaseStates.INPROCESS &&
            (item.type.id === ePhaseTypes.PICKUP ||
              item.type.id === ePhaseTypes.COMBINATION)
          );
        } else {
          return false;
        }
      });
    },
    editableWantedDatePlan() {
      return (
        this.phases.length == 0 ||
        !this.phases.find(
          p =>
            p.state?.id !== phaseStates.AWAITING &&
            p.type.id === ePhaseTypes.PICKUP,
        )
      );
    },
    hasPickUpPhaseInRoute() {
      return this.$store.getters["shipping/hasPickUpPhaseInRoute"];
    },
    isAdmin() {
      return auth.isAdmin();
    },
    isClientManager() {
      return auth.isClientManager();
    },
    isAllowEditPhase() {
      return this.$store.getters["shipping/isAllowEditPhase"];
    },
    isPhaseInCar() {
      return this.$store.getters["shipping/isPhaseInCar"];
    },
    firstPhaseAllowEditing() {
      return this.$store.getters["shipping/firstPhaseAllowEditing"];
    },
    isLastPhase() {
      return !!this.phases.find(item => item.isLast);
    },
  },
  methods: {
    async changeDates(fieldName) {
      if (fieldName === "readyPlan") {
        await changeReadyForShipmentPlan(this.id, this.items[0].plan.value);
      } else if (fieldName === "wantedDatePlan") {
        await changeDesiredDeliveryDatePlan(this.id, this.items[3].plan.value);
      } else if (fieldName === "factoryClosing") {
        await changeFactoryClosingPlanDate(this.id, this.items[2].plan.value);
      } else {
        const shippingDates = {
          wantedDateFrom: this.items[5].plan.value.dateFrom,
          wantedDateTo:
            this.items[5].plan.value.dateTo !== null
              ? this.items[5].plan.value.dateTo
              : this.items[5].plan.value.dateFrom,
          deliveryToUnloadingPlaceDate: this.items[4].plan.value,
        };
        await changeShippingDate(this.id, shippingDates);
      }
      await this.$store.dispatch("shipping/getShipping", this.id);
    },
    checkCanEditReadyToLoadDates() {
      if (
        (this.phaseInRoute || this.isInRoute || this.firstPhaseInProcess) &&
        this.firstPhaseAllowEditing &&
        this.isClientManager
      ) {
        return true;
      } else {
        return (
          !this.phaseInRoute &&
          !this.isInRoute &&
          !this.firstPhaseInProcess &&
          (this.isAdmin || this.isClientManager)
        );
      }
    },

    checkCanEditFactoryClosing() {
      if (
        this.hasPickUpPhaseInRoute &&
        this.firstPhaseAllowEditing &&
        this.isClientManager
      ) {
        return true;
      } else {
        return (
          !this.hasPickUpPhaseInRoute && (this.isAdmin || this.isClientManager)
        );
      }
    },
  },
};
</script>

<style scoped>
table.v-table tbody td:first-child {
  width: 140px;
}
tbody tr > td.date-picker {
  width: 33%;
}
tbody tr > td.date-picker .v-menu {
  min-width: 0 !important;
}
</style>
